export const appName = 'moneyTracker';
export const baseURL = 'https://0bs3hjnhh4.execute-api.eu-central-1.amazonaws.com/dev';
